// extracted by mini-css-extract-plugin
export default {"footer__wrapper":"Footer_footer__wrapper__1rU4p","footer__text":"Footer_footer__text__REJNX"};